var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMilchfrei = function SvgMilchfrei(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Milchfrei"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path283",
    d: "M10.5997 13.6223H6.51093C6.11828 13.6223 5.79986 13.3039 5.79986 12.9112V9M12.1994 12.2001V7.93375M12.1994 7.93375L10.7773 6.15574M12.1994 7.93375L13.6223 6.51093M10.7773 6.15574H7.00069L6.60111 6.6018M10.7773 6.15574V3.99688M6.60111 3.99688H11.3108M3.3427 3.34339L14.6566 14.6566M7.11516 6.15574V3.99688M9 1C13.4183 1 17 4.58169 17 9C17 13.4183 13.4183 17 9 17C4.58169 17 1 13.4183 1 9C1 4.58169 4.58169 1 9 1Z",
    stroke: "currentColor",
    strokeWidth: 1.248,
    strokeMiterlimit: 34.043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
export default SvgMilchfrei;